<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelEstado"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'isObject', 'useSigla'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'estado', null);
        return;
      }

      this.$emit('selectChange', 'estado', this.isObject == true ? e : e.id);
    },
    labelEstado({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      let selectedActual = this.options.find((option) => option[this.useSigla ? 'sigla' : 'id'] === value);
      if (value) {
        this.selected = selectedActual;
      } else {
        this.selected = this.options.find((option) => option[this.useSigla ? 'sigla' : 'id'] === null);
        selectedActual = this.options.find((option) => option[this.useSigla ? 'sigla' : 'id'] === null);
      }
      this.onChange(selectedActual);
      this.$emit('input', selectedActual);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getEstados({ order: 'nome' })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel), sigla: null }];
          }
          this.options = this.options.concat(res.data);
          if (this.nameField) {
            this.setValue(this.nameField);
            // this.onChange();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  watch: {
    nameField(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.options.length > 0) {
          this.setValue(this.nameField);
          // this.onChange();
        } else {
          this.setOptions(newVal);
        }
      }
    }
  },
  created() {
    this.setOptions();
  }
};
</script>

<style lang="scss" scoped></style>
